import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function TagInput({ tags, onChange }) {
  const [input, setInput] = useState('');

  const handleKeyDown = (e) => {
    const tag = input.trim().toLowerCase();
    if (e.key !== 'Enter' || !tag) return;
    e.preventDefault();
    if (!tags.includes(tag)) onChange([...tags, tag]);
    setInput('');
  };

  return (
    <div>
      <label className="text-[10px] uppercase tracking-wider text-earth/50 font-sans font-semibold mb-1 block">Tags</label>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {tags.map(t => (
          <span key={t} className="text-[10px] uppercase text-saffron bg-saffron/5 px-2 py-1 rounded font-sans flex items-center gap-1" data-testid={`blog-tag-${t}`}>
            {t} <button onClick={() => onChange(tags.filter(x => x !== t))} className="text-chilli/50 hover:text-chilli" data-testid={`remove-tag-${t}`}><X size={8} /></button>
          </span>
        ))}
      </div>
      <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={handleKeyDown} placeholder="Type & press Enter" className="w-full border border-earth/10 rounded px-2.5 py-1.5 text-xs font-sans focus:outline-none bg-cream/30" data-testid="blog-tag-input" />
    </div>
  );
}
